import {css} from 'styled-components';

export function addCreateFormInputDisabledStyles(isDisabled?: boolean) {
  if (!isDisabled) {
    return '';
  }
  return css`
    background: ${(p) => p.theme.foreground};
    border: 2px solid ${(p) => p.theme.greys.shade30};

    &:hover {
      background: ${(p) => p.theme.foreground};
      border: 2px solid ${(p) => p.theme.greys.shade30};
    }
  `;
}
